// "use client";
//
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "@/components/ui/table";
// import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
// import { Activity, Beaker, TrendingUp } from "lucide-react";
//
// interface MilkAnalysisData {
//   milk_kg?: number;
//   age1p?: number;
//   ebi?: number;
//   milk_acc?: number;
//   age_1p_acc?: number;
//   ebi_acc?: number;
//   beta_lac?: string;
//   kappa_c?: string;
//   beta_c?: string;
// }
//
// interface MilkAnalysisTableProps {
//   data: MilkAnalysisData[];
//   title?: string;
// }
//
// export default function MilkAnalysisTable({ data }: MilkAnalysisTableProps) {
//   return (
//     <div className="w-full  mx-auto space-y-6">
//       {/* Main Table Card */}
//       <Card className="border-0 shadow-2xl rounded-2xl overflow-hidden bg-white">
//         <CardHeader>
//           <CardTitle>Milk CLARIFIDE</CardTitle>
//         </CardHeader>
//         <CardContent className="p-0">
//           <div className="overflow-x-auto">
//             <Table>
//               <TableHeader>
//                 <TableRow className="border-0 bg-gradient-to-r from-slate-50
// to-gray-50"> <TableHead className="h-16 px-8 font-bold text-slate-700 text-base
// border-r border-slate-200"> <div className="flex items-center gap-2"> <Activity
// className="h-4 w-4 text-blue-600" /> </div> </TableHead>{" "} <TableHead
// className="h-16 px-8 font-bold text-slate-700 text-base border-r
// border-slate-200"> <div className="flex items-center gap-2"> <Activity
// className="h-4 w-4 text-blue-600" /> </div> </TableHead>{" "} <TableHead
// className="h-16 px-8 font-bold text-slate-700 text-base border-r
// border-slate-200"> <div className="flex items-center gap-2"> <Activity
// className="h-4 w-4 text-blue-600" /> Accuracy Metrics </div> </TableHead>
// <TableHead className="h-16 px-8 font-bold text-slate-700 text-base border-r
// border-slate-200"> <div className="flex items-center gap-2"> <TrendingUp
// className="h-4 w-4 text-emerald-600" /> Protein Analysis </div> </TableHead>
// </TableRow> <TableRow className="border-0 bg-gradient-to-r from-blue-50/50
// to-emerald-50/50"> <TableHead className="h-14 px-4 text-center font-semibold
// text-blue-700 border-r border-blue-200 bg-blue-50/70"> Accuracy Metrics
// </TableHead>{" "} <TableHead className="h-14 px-4 text-center font-semibold
// text-blue-700 border-r border-blue-200 bg-blue-50/70"> Milk Accuracy </TableHead>
// <TableHead className="h-14 px-4 text-center font-semibold text-amber-700 border-r
// border-amber-200 bg-amber-50/70"> Age 1P Accuracy </TableHead> <TableHead
// className="h-14 px-4 text-center font-semibold text-emerald-700 border-r
// border-emerald-200 bg-emerald-50/70"> EBI Accuracy </TableHead> <TableHead
// className="h-14 px-4 text-center font-semibold text-indigo-700 border-r
// border-indigo-200 bg-indigo-50/70"> Beta-lac </TableHead> <TableHead
// className="h-14 px-4 text-center font-semibold text-purple-700 border-r
// border-purple-200 bg-purple-50/70"> Kappa-c </TableHead> <TableHead
// className="h-14 px-4 text-center font-semibold text-teal-700 bg-teal-50/70">
// Beta-c </TableHead> </TableRow> </TableHeader> <TableBody> {!data ? ( <TableRow>
// <TableCell colSpan={6} className="h-32 text-center"> <div className="flex
// flex-col items-center gap-3 text-slate-500"> <Beaker className="h-12 w-12
// text-slate-300" /> <p className="text-lg font-medium"> No analysis data available
// </p> <p className="text-sm"> Upload your milk analysis data to get started </p>
// </div> </TableCell> </TableRow> ) : ( data.map((row, index) => ( <TableRow
// key={index} className="border-0 hover:bg-gradient-to-r hover:from-slate-50/50
// hover:to-blue-50/30 transition-all duration-300 group" > {/* Milk Accuracy */}
// <TableCell className={`h-16 px-4 text-center border-r border-blue-100 `} > <div
// className={`inline-flex items-center justify-center px-4 py-2 rounded-full
// border-2 transition-all duration-200 group-hover:scale-105`} > <span
// className={`font-bold text-lg ${row.milk_acc}`}> {row.milk_acc} </span> </div>
// </TableCell>  {/* Age 1P Accuracy */} <TableCell className={`h-16 px-4
// text-center border-r border-amber-100 }`} > <div className={`inline-flex
// items-center justify-center px-4 py-2 rounded-full border-2 transition-all
// duration-200 group-hover:scale-105`} > <span className={`font-bold text-lg
// ${row.age_1p_acc}`} > {row.age_1p_acc} </span> </div> </TableCell>  {/* EBI
// Accuracy */} <TableCell className={`h-16 px-4 text-center border-r
// border-emerald-100 ${row.ebi_acc}`} > <div className={`inline-flex items-center
// justify-center px-4 py-2 rounded-full border-2 ${row.ebi_acc} ${row.ebi_acc}
// transition-all duration-200 group-hover:scale-105`} > <span className={`font-bold
// text-lg ${row.ebi_acc}`}> {row.ebi_acc} </span> </div> </TableCell>  {/* Beta-lac
// */} <TableCell className="h-16 px-4 text-center border-r border-indigo-100
// bg-indigo-50/30"> <div className="inline-flex items-center justify-center px-4
// py-2 rounded-lg bg-white border border-indigo-200 shadow-sm transition-all
// duration-200 group-hover:shadow-md group-hover:scale-105"> <span
// className="font-bold text-lg text-indigo-700"> {row.beta_lac} </span> </div>
// </TableCell>  {/* Kappa-c */} <TableCell className="h-16 px-4 text-center
// border-r border-purple-100 bg-purple-50/30"> <div className="inline-flex
// items-center justify-center px-4 py-2 rounded-lg bg-white border
// border-purple-200 shadow-sm transition-all duration-200 group-hover:shadow-md
// group-hover:scale-105"> <span className="font-bold text-lg text-purple-700">
// {row.kappa_c} </span> </div> </TableCell>  {/* Beta-c */} <TableCell className="
// px-4 text-center bg-teal-50/30"> <div className="inline-flex items-center
// justify-center px-4 py-2 rounded-lg bg-white border border-teal-200 shadow-sm
// transition-all duration-200"> <span className="font-bold text-lg text-teal-700">
// {row.beta_c} </span> </div> </TableCell> </TableRow> )) )} </TableBody> </Table>
// </div> </CardContent> </Card> </div> ); }

"use client"

import {
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@heroui/table"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Activity, BarChart3, Beaker, TrendingUp } from "lucide-react"

interface MilkAnalysisData {
  milk_kg?: number
  age1p?: number
  ebi?: number
  milk_acc?: number
  age_1p_acc?: number
  ebi_acc?: number
  beta_lac?: string
  kappa_c?: string
  beta_c?: string
}

interface MilkAnalysisTableProps {
  data: MilkAnalysisData[]
  title?: string
}

export default function MilkAnalysisTable ( { data }: MilkAnalysisTableProps ) {
  return (
    <div className="w-full mx-auto space-y-8">
      <h2 className={ "flex flex-col gap-2 font-semibold text-lg" }>
        Milk Clarifide
      </h2>
      <div className="flex lg:flex-row flex-col md:flex-col gap-10">
        {/* Milk Production Metrics Table */ }
        <Card className="border border-slate-200 shadow-lg rounded-xl overflow-hidden bg-white">
          <CardHeader className="h-24 bg-gradient-to-r from-orange-50 to-red-50 border-b border-slate-200">
            <CardTitle className="flex items-center gap-3 text-md font-bold text-slate-800">
              <div className="0 bg-orange-100 rounded-lg">
                <BarChart3 className="h-5 w-5 text-orange-600" />
              </div>
              Milk Production Metrics
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <div className="overflow-x-auto">
              <Table isStriped isCompact>
                <TableHeader className="bg-slate-50 border-b border-slate-200">
                  <TableColumn className="h-2 px-2 font-semibold text-slate-700 text-xs uppercase tracking-wide text-center">
                    Milk (kg)
                  </TableColumn>
                  <TableColumn className="h-8 px-6 font-semibold text-slate-700 text-sm uppercase tracking-wide text-center">
                    Age 1P
                  </TableColumn>
                  <TableColumn className="h-8 px-6 font-semibold text-slate-700 text-sm uppercase tracking-wide text-center">
                    EBI
                  </TableColumn>
                </TableHeader>
                <TableBody>
                  { !data ? (
                    <TableRow>
                      <TableCell colSpan={ 4 } className="h-24 text-center">
                        <div className="flex flex-col items-center gap-3 text-slate-500">
                          <Beaker className="h-8 w-8 text-slate-300" />
                          <p className="text-lg font-medium">
                            No production data available
                          </p>
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    data.map( ( row, index ) => (
                      <TableRow
                        key={ `production-${index}` }
                        className={ `border-b border-slate-100 hover:bg-slate-50 transition-colors ${index % 2 === 0 ? "bg-white" : "bg-slate-50/50"
                          }` }
                      >
                        <TableCell className="h-8 px-6 text-center">
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-orange-100 text-orange-800">
                            { row.milk_kg || "-" }
                          </span>
                        </TableCell>
                        <TableCell className="h-8 px-6 text-center">
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-red-100 text-red-800">
                            { row.age1p || "-" }
                          </span>
                        </TableCell>
                        <TableCell className="h-8 px-6 text-center">
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-pink-100 text-pink-800">
                            { row.ebi || "-" }
                          </span>
                        </TableCell>
                      </TableRow>
                    ) )
                  ) }
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>

        {/* Accuracy Metrics Table */ }
        <Card className="border border-slate-200 shadow-lg rounded-xl overflow-hidden bg-white">
          <CardHeader className="bg-gradient-to-r from-blue-50 to-emerald-50 border-b border-slate-200">
            <CardTitle className="flex items-center gap-3 text-sm font-bold text-slate-800">
              <div className="p-2 bg-blue-100 rounded-lg">
                <Activity className="h-2 w-2 text-blue-600" />
              </div>
              Accuracy Metrics
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <div className="overflow-x-auto">
              <Table isCompact isStriped>
                <TableHeader className="bg-slate-50 border-b border-slate-200">
                  <TableColumn className="h-2 px-2 font-semibold text-slate-700 text-sm uppercase tracking-wide text-center">
                    Milk Accuracy (%)
                  </TableColumn>
                  <TableColumn className="h-2 px-2 font-semibold text-slate-700 text-sm uppercase tracking-wide text-center">
                    Age 1P Accuracy (%)
                  </TableColumn>
                  <TableColumn className="h-2 px-2 font-semibold text-slate-700 text-sm uppercase tracking-wide text-center">
                    EBI Accuracy (%)
                  </TableColumn>
                </TableHeader>
                <TableBody>
                  { !data ? (
                    <TableRow>
                      <TableCell colSpan={ 4 } className="h-24 text-center">
                        <div className="flex flex-col items-center gap-3 text-slate-500">
                          <Beaker className="h-6 w-6 text-slate-300" />
                          <p className="text-lg font-medium">
                            No accuracy data available
                          </p>
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    data.map( ( row, index ) => (
                      <TableRow
                        key={ `accuracy-${index}` }
                        className={ `border-b border-slate-100 hover:bg-slate-50 transition-colors ${index % 2 === 0 ? "bg-white" : "bg-slate-50/50"
                          }` }
                      >
                        <TableCell className="h-8 px-6 text-center">
                          <div className="flex items-center justify-center">
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-blue-100 text-blue-800">
                              { row.milk_acc || "-" }%
                            </span>
                          </div>
                        </TableCell>
                        <TableCell className="h-14 px-6 text-center">
                          <div className="flex items-center justify-center">
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-amber-100 text-amber-800">
                              { row.age_1p_acc || "-" }%
                            </span>
                          </div>
                        </TableCell>
                        <TableCell className="h-14 px-6 text-center">
                          <div className="flex items-center justify-center">
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-emerald-100 text-emerald-800">
                              { row.ebi_acc || "-" }%
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    ) )
                  ) }
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>

        {/* Protein Analysis Table */ }
        <Card className="border border-slate-200 shadow-lg rounded-xl overflow-hidden bg-white">
          <CardHeader className="bg-gradient-to-r from-indigo-50 to-purple-50 border-b border-slate-200">
            <CardTitle className="flex items-center gap-3 text-md font-bold text-slate-800">
              <div className="p-2 bg-indigo-100 rounded-lg">
                <TrendingUp className="h-3 w-3 text-indigo-600" />
              </div>
              Protein Analysis
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <div className="overflow-x-auto">
              <Table isCompact isStriped>
                <TableHeader className="bg-slate-50 border-b border-slate-200">
                  <TableColumn className="h-12 px-6 font-semibold text-slate-700 text-sm uppercase tracking-wide text-center">
                    Beta-Lactoglobulin
                  </TableColumn>
                  <TableColumn className="h-12 px-6 font-semibold text-slate-700 text-sm uppercase tracking-wide text-center">
                    Kappa-Casein
                  </TableColumn>
                  <TableColumn className="h-12 px-6 font-semibold text-slate-700 text-sm uppercase tracking-wide text-center">
                    Beta-Casein
                  </TableColumn>
                </TableHeader>
                <TableBody>
                  { !data ? (
                    <TableRow>
                      <TableCell colSpan={ 4 } className="h-32 text-center">
                        <div className="flex flex-col items-center gap-3 text-slate-500">
                          <Beaker className="h-12 w-12 text-slate-300" />
                          <p className="text-lg font-medium">
                            No protein analysis data available
                          </p>
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    data.map( ( row, index ) => (
                      <TableRow
                        key={ `protein-${index}` }
                        className={ `border-b border-slate-100 hover:bg-slate-50 transition-colors ${index % 2 === 0 ? "bg-white" : "bg-slate-50/50"
                          }` }
                      >
                        <TableCell className="h-14 px-6 text-center">
                          <span className="inline-flex items-center px-4 py-2 rounded-lg text-sm font-bold bg-indigo-100 text-indigo-800 border border-indigo-200">
                            { row.beta_lac || "-" }
                          </span>
                        </TableCell>
                        <TableCell className="h-14 px-6 text-center">
                          <span className="inline-flex items-center px-4 py-2 rounded-lg text-sm font-bold bg-purple-100 text-purple-800 border border-purple-200">
                            { row.kappa_c || "-" }
                          </span>
                        </TableCell>
                        <TableCell className="h-14 px-6 text-center">
                          <span className="inline-flex items-center px-4 py-2 rounded-lg text-sm font-bold bg-teal-100 text-teal-800 border border-teal-200">
                            { row.beta_c || "-" }
                          </span>
                        </TableCell>
                      </TableRow>
                    ) )
                  ) }
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
